(ns ui.gallery.confirm-modal
  "A Replicant replacement of `js/confirm` for the gallery, which can
   show a rich message and an optional checkbox. Modal `:params`:

   - `:title`, `:message` (hiccup or text), `:confirm-label`
   - `:checkbox-label` shows a checkbox, whose value the confirmed
     action reads from `[:gallery :confirm-checkbox?]` of the store
   - `:on-confirm` the actions dispatched after the modal closed"
  (:require [storrito.ui.button :as button]))

(defn render
  [state]
  (let [{:keys [title message confirm-label checkbox-label on-confirm]}
        (get-in state [:ui/modal :params])
        checked? (boolean (get-in state [:gallery :confirm-checkbox?]))]
    [:div
     [:h2.text-lg.font-semibold.text-gray-900.mb-3
      title]
     [:div.text-sm.text-gray-700
      message]
     (when checkbox-label
       [:label.flex.items-center.gap-2.cursor-pointer.mt-3.text-sm.text-gray-700
        [:input {:type "checkbox"
                 :checked checked?
                 :on {:change [[:store/assoc-in [:gallery :confirm-checkbox?] (not checked?)]]}}]
        checkbox-label])
     [:div.mt-5.flex.gap-2.justify-end
      [:button
       {:class button/button-cancel-css
        :type "button"
        :on {:click [[:ui/modal-close]]}}
       "Cancel"]
      [:button
       {:class button/button-primary-css
        :type "button"
        :on {:click (into [[:ui/modal-close]]
                          on-confirm)}}
       (or confirm-label "OK")]]]))

(def modal
  {:modal-id :modals/gallery-confirm
   :on-load (fn [_state]
              [[:store/assoc-in [:gallery :confirm-checkbox?] false]])
   :render #'render})
